import React from "react";

//UI Material
import { Card, Grid, Stack } from "@mui/material";

//Helpers
import {
  typographyForSubtitles,
  typographyForText,
} from "../../Helpers/typography";

//Local components
import CircularPercentage from "../basics/CircularPercentage";

//Date FNS
import { format } from "date-fns";

export default function ProductivitySummary({
  data,
  selectedDate,
  expectation = 10,
}) {
  // ==========> Component Functions<==========
  //Function to get all results by day
  const getDailyResults = () => {
    let count = {
      assembly: 0,
      testing: 0,
    };

    for (let i of data) {
      if (
        format(new Date(i.assemblyAt), "yyyy-MM-dd") ===
        format(new Date(selectedDate), "yyyy-MM-dd")
      ) {
        count.assembly++;
      }
      if (
        i.testedBy &&
        format(new Date(i.testedAt), "yyyy-MM-dd") ===
          format(new Date(selectedDate), "yyyy-MM-dd")
      ) {
        count.testing++;
      }
    }

    let percentage = {
      assemblyP: (100 * count.assembly) / expectation,
      assemblyC: count.assembly,
      testingP: (100 * count.testing) / expectation,
      testingC: count.testing,
    };

    return percentage;
  };

  // ==========> Component <==========
  return (
    <Card
      raised
      sx={{
        height: "100%",
        backgroundColor: "#003C3C",
      }}
    >
      <Grid
        container
        spacing={1}
        sx={{
          padding: "10px",
          color: "white",
        }}
      >
        <Grid item xs={12}>
          {typographyForSubtitles("Resumen de Productividad")}
        </Grid>
        <Grid item xs={12}>
          {typographyForText(`Meta diaria de producción: ${expectation}`)}
        </Grid>
        <Grid item xs={12} sx={{ marginBottom: "5px" }}>
          <Stack direction="row" spacing={3} justifyContent="center">
            <Stack direction="row" spacing={1} alignItems="center">
              <Stack alignItems="flex-start">
                {typographyForText("Ensamble")}
                {typographyForSubtitles(getDailyResults().assemblyC)}
              </Stack>
              <CircularPercentage value={getDailyResults().assemblyP} />
            </Stack>
            <Stack direction="row" spacing={1} alignItems="center">
              <Stack alignItems="flex-start">
                {typographyForText("Pruebas")}
                {typographyForSubtitles(getDailyResults().testingC)}
              </Stack>
              <CircularPercentage value={getDailyResults().testingP} />
            </Stack>
          </Stack>
        </Grid>
      </Grid>
    </Card>
  );
}
